'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
// import useAppLocale from '@/hooks/useAppLocale';
// import useLocaleChange from '@/hooks/useLocaleChange';
// import useLanguageChange from '@/hooks/useLanguageChange';

const notFoundContent: any = {
  en: {
    title: 'Page Not Found',
    subtitle:
      "We're sorry, the page you requested could not be found please go back to the homepage",
    button_text: 'Return Home',
  },
  de: {
    title: 'Seite nicht gefunden',
    subtitle:
      'Leider konnte diese Seite nicht gefunden werden. Bitte gehe zurück zur Startseite',
    button_text: 'zur Startseite',
  },
};

export default function PageNotFound() {
  const [locale, setLocale] = useState<string>('de');

  useEffect(() => {
    const pathLocale = window.location.pathname.split('/')[1]; // "en-DE"
    const [lang] = pathLocale.split('-');
    setLocale(lang);
  }, []);

  return (
    <main className="flex w-full flex-col items-center gap-y-[30px] border-b border-neutral-100 py-[120px]">
      <Image src="/404.svg" width={500} height={500} alt="not found" />
      <h1 className="text-h1 font-black text-title">
        {notFoundContent[locale].title}
      </h1>
      <p className="max-w-[500px] text-center text-lg text-paragraph">
        {notFoundContent[locale].subtitle}
      </p>
      <Link
        href="/"
        className="w-fit rounded-[30px] bg-primary px-[30px] py-[10px] text-white ring-2 ring-primary hover:bg-white hover:text-title"
      >
        {notFoundContent[locale].button_text}
      </Link>
    </main>
  );
}
